import {useEffect} from 'react'

import {useInView} from '@vio/core/src/_web/utils/browser/hooks/useInView'

import {useDealFreezeEducationBannerContext} from './DealFreezeEducationBannerProvider'

import type {DealFreezeEducationBannerPlacement} from './constants'

const SENTINEL_ROOT_MARGIN = '0px 0px -120px 0px'

interface UseDealFreezeEducationBannerResult {
  isVisible: boolean
  isReadyToTrigger: boolean
  inViewRef: (node?: Element | null) => void
  dismiss: () => void
  onCtaClick: () => void
}

export const useDealFreezeEducationBanner = (
  slot: DealFreezeEducationBannerPlacement
): UseDealFreezeEducationBannerResult => {
  const {
    placement,
    isTriggerable,
    visiblePlacement,
    startImpression,
    dismiss,
    onCtaClick
  } = useDealFreezeEducationBannerContext()

  const {ref: inViewRef, inView} = useInView({
    threshold: 0,
    rootMargin: SENTINEL_ROOT_MARGIN,
    initialInView: false
  })

  const isVisible = visiblePlacement === slot
  const isReadyToTrigger = isTriggerable && placement === slot && !isVisible

  useEffect(() => {
    if (!inView || !isReadyToTrigger) return

    startImpression()
  }, [inView, isReadyToTrigger, startImpression])

  return {isVisible, isReadyToTrigger, inViewRef, dismiss, onCtaClick}
}
